export default __webpack_public_path__ + "static/white-f47c261772526a4fc5d2afa6b0d96559.png";